/**
 * Includes the primary menu list entries shown on the very left side.
 * Primary list entries are shown in the menu section above the separator.
 */

import React, {useContext} from 'react';
import {List} from '@mui/material'
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import PeopleIcon from '@mui/icons-material/People';
import SchoolIcon from '@mui/icons-material/School';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {NavLink} from 'react-router-dom'
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';

import {useStyles} from 'components/admin/navigation/navItems/AdminNavItems.css'
import {FormattedMessage} from 'react-intl';
import {FirebaseAuthContext} from "../../../commons/firebase/FirebaseAuthProvider";
import DashboardIcon from "@mui/icons-material/Dashboard";
import {Sports} from "@mui/icons-material";


const AdminNavItemsPrimary = () => {
    const classes = useStyles()
    const {signedInUserRole} = useContext(FirebaseAuthContext)

    const showForRole = (allowedRoles, element) => {
        if (allowedRoles.includes(signedInUserRole)) {
            return element
        }

        return ''
    }

    return (
        <List>
            {showForRole(
                ['admin', 'contentCreator', 'organizer'],
                <ListItem button component={NavLink} exact activeClassName={classes.active} className={classes.inactive}
                          to={"/admin/dashboard"}>
                    <ListItemIcon>
                        <DashboardIcon/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.dashboard'}
                                      defaultMessage={'Dashboard'}/>
                </ListItem>
            )}

            {showForRole(
                ['admin', 'contentCreator', 'organizer'],
                <ListItem button component={NavLink} activeClassName={classes.active}
                          className={classes.inactive}
                          to={"/admin/videos"}>
                    <ListItemIcon>
                        <VideoLibraryIcon/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.videoAndScores'}
                                      defaultMessage={'Videos & Scores'}/>
                </ListItem>)}

            {showForRole(
                ['admin', 'contentCreator', 'organizer'],
                <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive}
                          to={"/admin/playlists"}>
                    <ListItemIcon>
                        <SubscriptionsIcon/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.playlists'}
                                      defaultMessage={'Playlists'}/>
                </ListItem>)}

            {showForRole(
                ['admin', 'organizer'],
                <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive}
                          to={"/admin/courses"}>
                    <ListItemIcon>
                        <SchoolIcon/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.courses'}
                                      defaultMessage={'Courses'}/>
                </ListItem>)}

            {showForRole(
                ['admin', 'organizer'],
                <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive}
                          to={"/admin/users"}>
                    <ListItemIcon>
                        <PeopleIcon/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.users'}
                                      defaultMessage={'Users'}/>
                </ListItem>)}

            {showForRole(
                ['admin', 'contentCreator', 'organizer'],
                <ListItem button component={NavLink} activeClassName={classes.active}
                          className={classes.inactive}
                          to={"/admin/challengedDecisions"}>
                    <ListItemIcon>
                        <Sports/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.challengedDecisions'}
                                      defaultMessage={'Challenged Decisions'}/>
                </ListItem>)}

            {showForRole(
                ['admin', 'organizer'],
                <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive}
                          to={"/admin/statistics"}>
                    <ListItemIcon>
                        <BarChartIcon/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.statistics'}
                                      defaultMessage={'Statistics'}/>
                </ListItem>)}

            {showForRole(
                ['admin', 'contentCreator', 'organizer'],
                <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive}
                          to={"/common/profile"}>
                    <ListItemIcon>
                        <AccountCircleIcon/>
                    </ListItemIcon>
                    <FormattedMessage id={'app.navigation.profile'}
                                      defaultMessage={'Profile'}/>
                </ListItem>)}
        </List>
    )
}

export default AdminNavItemsPrimary
